// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3YIjR","inputWrap":"Table_inputWrap___tt61","col":"Table_col__4M6jd","bmiTooltip":"Table_bmiTooltip__3YCSD"};